<template lang="pug">
    div.sunWrapper
        div.sun(:style="opacityIntesivity")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            mood: VueTypes.number.def(0)
        },
        computed: {
            /**
             * Update position and opacity based on mood prop.
             * @returns {{top: string, opacity: string}}
             */
            opacityIntesivity() {
                return {
                    opacity: `${this.mood >= 80 ? this.mood * 0.005 : 0}`,
                    top: `${100 - (this.mood - 80) * 2}%`
                };
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .sunWrapper
        position: absolute
        width: 100%
        height: 47%
        overflow: hidden
        left: 0
        top: 0

    .sun
        z-index: 2
        width: 60px
        height: 60px
        border-radius: 60px
        position: absolute
        right: 15%
        top: 100%
        background: lightgoldenrodyellow
        box-shadow: 0 0 30px rgba(lightgoldenrodyellow, 0.85)
</style>
